import { render, staticRenderFns } from "./AcceptPrivacyPolicyCheck.vue?vue&type=template&id=b37bfc36&"
import script from "./AcceptPrivacyPolicyCheck.vue?vue&type=script&lang=js&"
export * from "./AcceptPrivacyPolicyCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b37bfc36')) {
      api.createRecord('b37bfc36', component.options)
    } else {
      api.reload('b37bfc36', component.options)
    }
    module.hot.accept("./AcceptPrivacyPolicyCheck.vue?vue&type=template&id=b37bfc36&", function () {
      api.rerender('b37bfc36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/AcceptPrivacyPolicyCheck.vue"
export default component.exports